import { reactive } from 'vue';
import { TUNING_PRESETS } from '@/service/audio/audioEngine';

const REFERENCE_INSTRUMENT_KEY = 'tuner-reference-instrument';

const loadReferenceInstrument = () => {
  try {
    return localStorage.getItem(REFERENCE_INSTRUMENT_KEY) || 'acoustic_guitar_steel';
  } catch {
    return 'acoustic_guitar_steel';
  }
};

export const REFERENCE_INSTRUMENTS = [
  { value: 'acoustic_guitar_steel', labelKey: 'tuner.refGuitarSteel' },
  { value: 'acoustic_guitar_nylon', labelKey: 'tuner.refGuitarNylon' },
  { value: 'acoustic_grand_piano', labelKey: 'tuner.refPiano' },
  { value: 'synth', labelKey: 'tuner.refSynth' },
];

// Preset sentinela: nenhum instrumento — afinador 100% cromático,
// sem fileira de cordas nem destaque de corda mais próxima.
export const CHROMATIC_PRESET = {
  id: 'chromatic',
  name: 'chromatic',
  instrument: 'chromatic',
  instrumentLabel: 'chromatic',
  strings: [],
};

export const tunerStore = reactive({
  isOpen: false,
  isFullscreen: false,
  selectedTuning: TUNING_PRESETS[0],
  isAutoDetect: true,
  targetStringIndex: null,
  referenceInstrument: loadReferenceInstrument(),

  setReferenceInstrument(id) {
    this.referenceInstrument = id;
    try {
      localStorage.setItem(REFERENCE_INSTRUMENT_KEY, id);
    } catch {
      // ignora
    }
  },

  openBar() {
    this.isOpen = true;
    this.isFullscreen = false;
  },

  openFullscreen() {
    this.isOpen = true;
    this.isFullscreen = true;
  },

  minimize() {
    this.isFullscreen = false;
  },

  close() {
    this.isOpen = false;
    this.isFullscreen = false;
  },

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.openBar();
    }
  }
});

export default tunerStore;
